import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { HomepagePageUserData } from './api.graphql';
import type { HomepagePageUserDataQuery, HomepagePageUserDataQueryVariables } from './api.graphql';

export async function getHomepagePageUserData({ gql: { fetch } }: UtilityContext): Promise<HomepagePageUserDataQuery> {
	const { data } = await fetch<HomepagePageUserDataQuery, HomepagePageUserDataQueryVariables>({
		query: HomepagePageUserData,
		rejectOnError: true,
	});
	return data;
}
